import React from 'react'
import PropTypes from 'prop-types'

import Link from 'components/Link'
import Tag from 'components/Tag'
import Paragraph from 'components/Paragraph'
import BlogPostImage from 'components/BlogPostImage'

const BlogPostItemFeatured = ({
  url = '',
  title = '',
  image = '',
  excerpt = '',
  category
}) => {
  const {
    data: {
      title: categoryTitle,
      tag_color_text: categoryTagColor,
      tag_color_background: categoryTagBackgroundColor,
      filter_color_light: categoryFilterColorLight,
      filter_color_dark: categoryFilterColorDark
    }
  } = category.document

  return (
    <Link className='BlogPostItemFeatured' to={ url }>
      <div className='BlogPostItemFeatured-image'>
        <BlogPostImage
          filterColorLight={ categoryFilterColorLight }
          filterColorDark={ categoryFilterColorDark }
          src={ image }
        />
      </div>
      <div className='BlogPostItemFeatured-text'>
        <Tag style='rounded' label={ categoryTitle } className='BlogPostItemFeatured-tag' color={ categoryTagColor } backgroundColor={ categoryTagBackgroundColor } />
        <Paragraph style='bigInter' className='BlogPostItemFeatured-title'>{ title }</Paragraph>
        <Paragraph style='small' className='BlogPostItemFeatured-excerpt'>{ excerpt }</Paragraph>
      </div>
    </Link>
  )
}

BlogPostItemFeatured.propTypes = {
  url: PropTypes.string,
  title: PropTypes.string,
  image: PropTypes.string,
  excerpt: PropTypes.string,
  tag: PropTypes.string,
  category: PropTypes.object
}

export default BlogPostItemFeatured
